import { Component, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Store } from '@softline/core';
import { DefinitionStore, SOFTLINE_FEATURE_DEFINITIONS } from '@softline/dynamic';
import {
  SOFTLINE_DEFINITION_ARBEITSBERICHT_EDIT,
  SOFTLINE_DEFINITION_ARBEITSBERICHT_LIST,
  SOFTLINE_DEFINITION_ARBEITSBERICHT_QUERY,
} from '../arbeitsbericht.api';
import { SOFTLINE_GEWERBE_ARBEITSBERICHT_SELECTED_PERSONS } from '../arbeitsbericht.shared';
import { TimeReportsService } from '../services/time-reports.service';
import { TimeReportsRepository } from '../repository/time-reports.repository';

@Component({
  selector: 'soft-gewerbe-time-report',
  templateUrl: './time-report.component.html',
  styleUrls: ['./time-report.component.css'],
  imports: [RouterModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    {
      provide: SOFTLINE_GEWERBE_ARBEITSBERICHT_SELECTED_PERSONS,
      useFactory: () => signal([]),
    },
    TimeReportsService,
    TimeReportsRepository,
  ],
})
export class TimeReportComponent implements OnInit {
  constructor(
    private store: Store,
    protected router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    await this.store.dispatch(
      SOFTLINE_FEATURE_DEFINITIONS,
      DefinitionStore.actions.load,
      { name: SOFTLINE_DEFINITION_ARBEITSBERICHT_QUERY }
    );
    await this.store.dispatch(
      SOFTLINE_FEATURE_DEFINITIONS,
      DefinitionStore.actions.load,
      { name: SOFTLINE_DEFINITION_ARBEITSBERICHT_LIST }
    );
    await this.store.dispatch(
      SOFTLINE_FEATURE_DEFINITIONS,
      DefinitionStore.actions.load,
      { name: SOFTLINE_DEFINITION_ARBEITSBERICHT_EDIT }
    );
  }
}
